import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { List } from "react-virtualized";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import RadioGroup from "@material-ui/core/RadioGroup";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import FormControl from "@material-ui/core/FormControl";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { MuiThemeProvider } from "@material-ui/core/styles";
import PlayerDropdownSearch from "../PlayerDropdownSearch";
import http from "../../util/http";
import aceTheme from "../../util/aceTheme";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  button: {
    margin: theme.spacing.unit,
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
  smallCell: { padding: "0 2px", textAlign: "center" },
});

class Rollout extends Component {
  state = {
    reasonVoid: "Perform a Search",
    loading: false,
    selectedPlayer: "",
    type: "percentage",
    filter: "",
    value: 10,
    rolloutResponseList: [],
    rolloutResponseListIntact: [],
  };
  async componentDidMount() {
    try {
      this.setState({
        loading: true,
        rolloutResponseList: [],
        rolloutResponseListIntact: [],
      });
      const rolloutResponseList = await http.sendHelperCommand(
        "RolloutRequestListHelper.aspx",
        {}
      );
      this.setState({
        rolloutResponseList,
        rolloutResponseListIntact: rolloutResponseList,
        loading: false,
      });
    } catch (err) {
      this.setState({
        reasonVoid: err.message,
        loading: false,
      });
    }
  }
  handleChange = (key) => (event, value) => {
    this.setState({
      [key]: value,
    });
  };
  setRollout = async () => {
    try {
      this.setState({
        loading: true,
        rolloutResponseList: [],
        rolloutResponseListIntact: [],
      });
      const { type, value } = this.state;
      const rolloutRequestPayload = JSON.stringify({ type, value });
      const rolloutResponseList = await http.sendHelperCommand(
        "RolloutRequestHelper.aspx",
        { payload: rolloutRequestPayload }
      );
      this.setState({
        rolloutResponseList,
        rolloutResponseListIntact: rolloutResponseList,
        loading: false,
      });
    } catch (err) {
      this.setState({
        reasonVoid: err.message,
        loading: false,
      });
    }
  };
  addPlayerToRollout = async () => {
    try {
      const { selectedPlayer } = this.state;
      const playerId = selectedPlayer.split("|")[0];
      if (playerId.length) {
        this.setState({
          loading: true,
        });
        const rolloutResponseList = await http.sendHelperCommand(
          "RolloutAddPlayerHelper.aspx",
          { playerId }
        );
        this.setState({
          rolloutResponseList,
          rolloutResponseListIntact: rolloutResponseList,
          loading: false,
          selectedPlayer: "",
        });
      }
    } catch (err) {
      this.setState({
        reasonVoid: err.message,
        loading: false,
      });
    }
  };
  handlePropChange = (prop) => (event) => {
    let newValue = event.target.value;
    this.setState({
      [prop]: newValue,
    });
  };
  performFilter = (event) => {
    const filter = (event.target.value + "").toUpperCase();
    const { rolloutResponseListIntact } = this.state;
    if (filter !== "") {
      const filteredRolloutResponseList = _.filter(
        rolloutResponseListIntact,
        (rollout) => {
          return (
            _.includes(rollout.Agent, filter) ||
            _.includes(rollout.Player, filter)
          );
        }
      );
      this.setState({
        rolloutResponseList: filteredRolloutResponseList,
      });
    } else {
      this.setState({
        rolloutResponseList: _.clone(rolloutResponseListIntact),
      });
    }
    this.setState({
      filter,
    });
  };
  renderRow = ({ index, key, style }) => {
    const { rolloutResponseList } = this.state;
    return (
      <div key={key} style={style} className="row">
        <ListItem button style={{ padding: 0 }}>
          <ListItemText
            primary={rolloutResponseList[index].Player}
            secondary={rolloutResponseList[index].Agent}
          />
        </ListItem>
      </div>
    );
  };
  render() {
    const { classes, prmIdAgent } = this.props;
    const { type, value, loading, filter, rolloutResponseList } = this.state;
    return (
      <MuiThemeProvider theme={aceTheme}>
        <div style={{ minHeight: 450 }}>
          <form autoComplete="off" className={classes.container}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControl component="fieldset">
                  <FormLabel>Type</FormLabel>
                  <RadioGroup
                    row
                    name="type"
                    aria-label="type"
                    value={type}
                    onChange={this.handleChange("type")}
                  >
                    <FormControlLabel
                      value="percentage"
                      control={<Radio />}
                      label="Percentage"
                    />
                    <FormControlLabel
                      value="total"
                      control={<Radio />}
                      label="Total"
                    />
                  </RadioGroup>
                </FormControl>
                <FormControl>
                  <TextField
                    type="number"
                    label="Value"
                    placeholder="Value"
                    onChange={this.handlePropChange("value")}
                    value={value}
                  />
                </FormControl>
                <FormControl>
                  <Button
                    style={{ marginTop: 20 }}
                    color="primary"
                    variant="contained"
                    onClick={this.setRollout}
                  >
                    Set Rollout
                  </Button>
                </FormControl>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControl
                  className={classes.formControl}
                  style={{ marginTop: 2 }}
                >
                  <PlayerDropdownSearch
                    agentFilter={false}
                    displayAllPlayers={false}
                    onEnter={this.addPlayerToRollout}
                    prmIdAgent={prmIdAgent}
                    onSelectPlayer={(selectedPlayer) => {
                      this.setState({ selectedPlayer });
                    }}
                  />
                </FormControl>
                <FormControl style={{ marginTop: 20 }}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={this.addPlayerToRollout}
                  >
                    Add To Rollout
                  </Button>
                </FormControl>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControl>
                  <TextField
                    label="Filter"
                    placeholder="Filter"
                    onChange={this.performFilter}
                    value={filter}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </form>
          {loading && <LinearProgress className={classes.progressLinear} />}
          <Grid item sm>
            <Paper className={classes.paper}>
              <List
                width={300}
                height={400}
                rowHeight={46}
                rowRenderer={this.renderRow}
                rowCount={rolloutResponseList.length}
                overscanRowCount={1}
              />
            </Paper>
          </Grid>
        </div>
      </MuiThemeProvider>
    );
  }
}

Rollout.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  prmIdAgent: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(Rollout);
